// exportCsvData.js

import { dateformation } from "src/components/date-format-mdy";

export const getCsvData = (tableData = {}) => {
    console.log("🚀 ~ getCsvData ~ tableData:", tableData)
    return tableData?.map((row) => {
        const filteredRow = {};
        const fields = {
            'Chart of account': "'" + row?.account_chart?.code + "'",
            'Account Name': row?.account_chart?.name,
            'Date': dateformation(row?.invoice_date) || dateformation(row?.date_of_receipt) || dateformation(row?.date),
            'Account Type': row?.account_chart?.account_type?.name,
            'bank_information': row?.bank_information?.bank_name,
            'opening_balance': row?.bank_information?.opening_balance,
            'Credit': row?.credit,
            'Debit': row?.debit,
            'Comulative Credit': row?.cumulative_credit,
            'Comulative Debit': row?.cumulative_debit,
            'Balance': row?.balance,
            'Notes/Remarks': row?.notes || row?.note,
        };

        Object.keys(fields).forEach((key) => {
            if (key !== 'actions') {
                filteredRow[key] = fields[key];
            }
        });
        return filteredRow;
    });
};
